import * as $swal from "sweetalert2";
import Vue from "vue";

const axios = require('axios');
const base_url = 'https://api.cluna.app/'
const cookie_setting = "stg-sven-tdh";
const storage_path = "qti-innerStore-tdh";
const language = "accept-lang";

let bus = new Vue()

let oracle = {
    shop_description(item) {
        if (item == null) return ""
        try {
            return (!this.isEN() ? item.shop_description : (item.shop_description_en ? item.shop_description_en : (item.shop_description ? item.shop_description : ''))).toString().trim()
        } catch (e) {
            return ""
        }
    },
    shop_address(item) {
        if (item == null) return ""
        try {
            return (!this.isEN() ? item.shop_address : (item.shop_address_en ? item.shop_address_en : (item.shop_address ? item.shop_address : ''))).toString().trim()
        } catch (e) {
            return ""
        }
    },
    category_name(item) {
        if (item == null) return ""
        try {
            return (!this.isEN() ? item.category_name : (item.category_name_en ? item.category_name_en : (item.category_name ? item.category_name : ''))).toString().trim()
        } catch (e) {
            return ""
        }
    },
    product_description(item) {
        if (item == null) return ""
        try {
            return (!this.isEN() ? item.product_description : (item.product_description_en ? item.product_description_en : (item.product_description ? item.product_description : ''))).toString().trim()
        } catch (e) {
            return ""
        }
    },
    product_title(item) {
        if (item == null) return ""
        try {
            return (!this.isEN() ? item.product_title : (item.product_title_en ? item.product_title_en : (item.product_title ? item.product_title : ''))).toString().trim()
        } catch (e) {
            return ""
        }
    },
    shop_name(item) {
        if (item == null) return ""
        try {
            return (!this.isEN() ? item.shop_name : (item.shop_name_en ? item.shop_name_en : (item.shop_name ? item.shop_name : ''))).toString().trim()
        } catch (e) {
            return ""
        }
    },
    toggleLanguage() {
        this.setData(language, !this.isEN() ? 'en' : 'fa');
    },
    isEN() {
        return this.getData(language) == 'en';
    },
    refresh(keySet, value, isLoad) {
        if (!isLoad) {
            this.setData(keySet, value)
        } else {
            let saved = this.getData(keySet);
            if (saved != null) {
                for (let key in value) {
                    if (saved[key] != null) {
                        value[key] = saved[key]
                    }
                }
            }
        }
    }, getBasket() {
        let data = localStorage.getItem("basket-cluna");
        if (data == null || data.trim().length == 0) {
            return [];
        }
        let array = data.split(",");
        if (array == null) {
            array = [];
        }
        return array;
    }, isMobile() {
        return window.screen.width < 700;
    }, setShop(request) {
        this.setData('shop-selected', request);
    }, getShop() {
        return this.getData('shop-selected');
    }, getCount(id, shopId) {
        if (shopId != null && this.getShop() != null) {
            if (this.getShop() != shopId) {
                return 0
            }
        }
        if (id != null) {
            let sum = 0
            let array = this.getBasket();
            for (let i = 0; i < array.length; i++) {
                if (array[i] == id) {
                    sum++
                }
            }
            return sum
        }
        let array = this.getBasket()
        if (array == null || array.length == 0) return 0
        let unique = []
        for (let i = 0; i < array.length; i++) {
            let exist = false
            let pr = array[i]
            for (let j = 0; j < unique.length; j++) {
                if (pr == unique[j]) {
                    exist = true
                    break
                }
            }
            if (!exist) {
                unique.push(pr)
            }
        }
        return unique.length
    }, addToBasket(id) {
        let array = this.getBasket();
        array.push(id);
        localStorage.setItem("basket-cluna", array.join(","));
    }, removeAllFromBasket(id) {
        let array = this.getBasket();
        array = array.filter(function (item) {
            return item !== id;
        });
        localStorage.setItem("basket-cluna", array.join(","));
    }, removeFromBasket(id) {
        let array = this.getBasket();
        for (let i = 0; i < array.length; i++) {
            if (array[i] == id) {
                array.splice(i, 1);
                localStorage.setItem("basket-cluna", array.join(","));
                return;
            }
        }
    }, clearBasket() {
        localStorage.setItem("basket-cluna", "");
    }, format(number) {
        if (number == 0) {
            return 0;
        } else if (number == null) {
            return "";
        }
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }, encode(object) {
        if (object == null) {
            return null;
        }
        return encodeURIComponent(JSON.stringify(object));
    }, decode(object) {
        if (object == null) {
            return null;
        }
        return this.nullify(JSON.parse(decodeURIComponent(object)));
    }, setToken(request) {
        this.setData(storage_path, request, true);
    }, getToken() {
        return this.getData(storage_path, true);
    }, getData(key, secure) {
        let token = localStorage.getItem(key);
        if (token != null && token.length > 0) {
            if (!secure) {
                return JSON.parse(decodeURIComponent(token));
            } else {
                return atob(token);
            }
        }
        let name = key + "=";
        let data = document.cookie.split(";");
        for (let i = 0; i < data.length; i++) {
            let c = data[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                if (!secure) {
                    return JSON.parse(decodeURIComponent(c.substring(name.length, c.length)));
                } else {
                    return atob(c.substring(name.length, c.length));
                }
            }
        }
        return null;
    }, formatDate(date, withHours = true) {
        let p = new Intl.DateTimeFormat(this.isEN() ? 'en-US' : 'fa-IR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).formatToParts(new Date(date)).reduce((acc, part) => {
            acc[part.type] = part.value;
            return acc;
        }, {});
        if (withHours) {
            return `${p.year}/${p.month}/${p.day} ${p.hour}:${p.minute}`;
        } else {
            return `${p.year}/${p.month}/${p.day}`;
        }
    }, setData(key, value, secure) {
        let data = "";
        if (value != null) {
            if (secure != null && secure) {
                data = btoa(value)
            } else {
                data = encodeURIComponent(JSON.stringify(value))
            }
        }
        localStorage.setItem(key, data);
        if (!secure) {
            return;
        }
        let date = new Date();
        date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
        let expires = "expires=" + date.toUTCString();
        document.cookie = key + "=" + data + ";" + expires + ";path=/";
    }, logOut() {
        let date = new Date();
        date.setTime(date.getTime() - 100 * 24 * 60 * 60 * 1000);
        let expires = "expires=" + date.toUTCString();
        document.cookie = storage_path + "=;" + expires + ";path=/";
        localStorage.removeItem(cookie_setting);
        localStorage.removeItem(storage_path);
        event.$emit('login-popup')
    }, nullify(data) {
        let newData = {}
        for (let key in data) {
            let value = data[key];
            if (!this.isEmpty(value)) {
                newData[key] = value;
            }
        }
        return newData;
    }, scrollToTop() {
        window.scrollTo(0, 0);
    }, openLink(URL) {
        window.open(URL, '_blank');
    }, isEmpty(data) {
        return data == null || (data == '' && data != 0);
    }, isString(variable) {
        return (typeof variable === 'string' || variable instanceof String)
    }, axios(url, data, onSuccess, onError, onProgress, extra) {
        axios({
            method: 'post',
            url: base_url + url,
            headers: {
                'Authorization': this.getToken(),
                'Content-Type': 'application/json;charset=UTF-8'
            },
            data: this.nullify(data),
            timeout: 30000,
            onDownloadProgress: function (progressEvent) {
                if (onProgress != null) {
                    onProgress(progressEvent)
                }
            },
        }).then(function (response) {
            if (response != null && response.data != null && response.data.success != null && response.data.success == true) {
                if (response.headers != null && response.headers['authorization'] != null) {
                    oracle.setToken(response.headers['authorization'])
                } else if (response.headers != null && response.headers['Authorization'] != null) {
                    oracle.setToken(response.headers['Authorization'])
                }
                if (onSuccess != null) {
                    if (extra != null) {
                        onSuccess(response.data, extra);
                    } else {
                        onSuccess(response.data);
                    }
                }
            } else {
                handleError(response != null ? response : null, onError)
            }
        }).catch(function (error) {
            handleError(error != null && error.response != null ? error.response : null, onError)
        });
    }, showMessage(message, action, lambda, resource) {
        let font = 'font-family: ' + (this.isEN() ? 'Nunito' : 'Vazirmatn') + ';'
        $swal.fire({
            html: '<p style="' + font + '" class="mrx-3 mlx-3 multi-line ' + '">' + message + '</p>',
            showCloseButton: true,
            showConfirmButton: action != null,
            confirmButtonText: '<p class="' + ' font-weight-bold ' + '" style="text-align: center !important; margin-top: auto; margin-bottom: 0 !important;' + font + '">' + action + '</p>',
            imageUrl: (resource != null ? require("@/assets/image/" + resource + ".png") : (lambda == null ? require("@/assets/image/warning.png") : null)),
            imageWidth: 70,
            imageHeight: 70,
            customClass: {
                popup: 'format'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                if (lambda != null) {
                    lambda()
                }
            }
        })
    }, showSuccess(message) {
        this.showMessage(message, null, null, 'checked')
    }, axiosUpload(data, onSuccess, onError, onProgress, customName) {
        let formData = new FormData()
        if (customName != null) {
            formData.append("file", data, customName)
        } else {
            formData.append("file", data)
        }
        axios({
            method: 'post',
            url: base_url + "file/upload",
            data: formData,
            headers: {
                'Authorization': this.getToken(),
                'Content-Type': 'multipart/form-data'
            },
            timeout: 120000,
            onDownloadProgress: function (progressEvent) {
                if (onProgress != null) {
                    onProgress(progressEvent)
                }
            },
            onUploadProgress: function (progressEvent) {
                if (onProgress != null) {
                    onProgress(progressEvent);
                }
            }
        }).then(function (response) {
            if (response != null && response.data != null && response.data.success != null && response.data.success == true) {
                if (onSuccess != null) {
                    onSuccess(response.data)
                }
            } else {
                handleError(response != null ? response : null, onError)
            }
        }).catch(function (error) {
            handleError(error != null && error.response != null ? error.response : null, onError)
        });
    }, translate(phrase) {
        let isEN = this.isEN();
        if (!isEN) return phrase;
        let translations = require("./translations").default;
        for (let key in translations) {
            if (key.toString().toLowerCase().trim() == phrase.toString().toLowerCase().trim()) {
                let str = translations[key];
                return str.charAt(0).toUpperCase() + str.slice(1);
            }
        }
        return phrase;
    }
}

function handleError(param, onError) {
    if (param != null && param.data != null) {
        param = param.data
    }
    if (onError != null) {
        onError(param)
    }
    if (param != null && param.status != null && param.status == 401) {
        oracle.logOut()
        return
    }
    if (param != null && param.message != null) {
        oracle.showMessage(param.message, null, null, "error")
    }
}

export default oracle
export const event = bus
export const globals = {}
